<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                   <b-form-group :label="$t('name')">
                       <ValidationProvider
                           name="name"
                           rules="required"
                           v-slot="{ valid, errors }"
                       >
                           <b-input-group class="mb-3" :prepend="$t('variable_language')">
                               <b-form-input
                                   v-model="form.name"
                                   :class="errors[0] ? 'is-invalid' : ''"
                               >
                               </b-form-input>
                           </b-input-group>
                           <b-form-invalid-feedback
                               v-if="errors[0]"
                               v-html="errors[0]"
                               class="mb-2"
                           ></b-form-invalid-feedback>
                       </ValidationProvider>
                       <ValidationProvider
                           name="name_en"
                           v-slot="{ valid, errors }"
                       >
                           <b-input-group prepend="EN">
                               <b-form-input
                                   v-model="form.name_en"
                                   :class="errors[0] ? 'is-invalid' : ''"
                               >
                               </b-form-input>
                           </b-input-group>
                           <b-form-invalid-feedback
                               v-if="errors[0]"
                               v-html="errors[0]"
                           ></b-form-invalid-feedback>
                       </ValidationProvider>
                   </b-form-group>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('code')">
                            <b-form-input v-model="form.code"
                                                 :validate-error="errors[0]"></b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="form.start_date" :is-time="true" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')" class="position-relative">
                            <select-date :is-time="true" v-model="form.end_date" :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2" :disabled="formLoading">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import TicketEventService from "@/services/TicketEventService";
    import TicketEventSelectbox from "@/components/interactive-fields/TicketEventSelectbox.vue";

    export default {
        components: {
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    name: null,
                    name_en: null,
                    code: null,
                    start_date: null,
                    end_date: null,
                }
            }
        },
        methods: {
            async createForm() {
                if(this.checkPermission('ticketeventtype_store')){
                    const isValid = await this.$refs.formModalValidate.validate()
                    if (isValid) {
                        this.formLoading = true;
                        TicketEventService.store(this.form)
                                      .then((response) => {
                                          this.$toast.success(this.$t("api." + response.data.message));
                                          this.$emit("createFormSuccess")
                                      })
                                      .catch((error) => {
                                          this.showErrors(error, this.$refs.formModalValidate)
                                      }).finally(() => {
                            this.formLoading = false;
                        });
                    }
                } else {
                    this.$toast.error(this.$t("you_are_not_authorized_for_this_operation"))
                }

            }
        }
    }
</script>
